module.exports = __webpack_public_path__ + "img/11.5a1739f7.svg";